import React, { useState } from "react";
import { observer } from "mobx-react";

// A reply thread as a conversation. Long bodies collapse so a single card
// can't take over the thread; the full text is one click away.
const COLLAPSE_CHARS = 320;

const formatWhen = at => {
  if (!at) return "";
  const date = new Date(at);
  if (Number.isNaN(date.getTime())) return at;
  return date.toLocaleString(undefined, {
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit"
  });
};

const Message = ({ message }) => {
  const [expanded, setExpanded] = useState(false);
  const isLong = (message.body || "").length > COLLAPSE_CHARS;
  const body =
    isLong && !expanded ? `${message.body.slice(0, COLLAPSE_CHARS)}…` : message.body;

  return (
    <li
      className={`copilotThreadView__msg${
        message.outbound ? " copilotThreadView__msg--out" : ""
      }`}
    >
      <div className="copilotThreadView__msgHead">
        <span className="copilotThreadView__from">{message.from}</span>
        {message.at && (
          <span className="copilotThreadView__when">{formatWhen(message.at)}</span>
        )}
      </div>
      {message.subject && (
        <div className="copilotThreadView__subject">{message.subject}</div>
      )}
      {body && <div className="copilotThreadView__body">{body}</div>}
      {isLong && (
        <button
          type="button"
          className="copilotThreadView__more"
          aria-expanded={expanded}
          onClick={() => setExpanded(v => !v)}
        >
          {expanded ? "Show less" : "Show full message"}
        </button>
      )}
    </li>
  );
};

const ThreadViewBlock = observer(({ block }) => {
  const messages = block.messages || [];
  if (!messages.length) return null;

  return (
    <div className="copilotThreadView">
      {block.title && <div className="copilotThreadView__title">{block.title}</div>}
      <ol className="copilotThreadView__list">
        {messages.map((message, index) => (
          <Message key={`${message.from}-${message.at}-${index}`} message={message} />
        ))}
      </ol>
    </div>
  );
});

export default ThreadViewBlock;
